import { useQuery } from '@tanstack/react-query';
import { API } from '@/services/api.service';
import { QUERY_KEY } from '@/shared/constants';

export function useEmployee(employeeId) {
  return useQuery({
    queryKey: [QUERY_KEY.employee, employeeId],
    queryFn: async () => {
      if (!employeeId) return null;
      return API.employees.getEmployeeById(employeeId);
    },
    enabled: !!employeeId,
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
  });
}
